import { css } from '@emotion/react';

/**
 *  bluegray
 * @returns #F1F3F5
 *  */
export const BLUE_GRAY: string = '#F1F3F5';

/**
 *  lightGray
 * @returns {string} #f2f2f2
 *  */
export const LIGHT_GRAY: string = '#f2f2f2';

/**
 *  gray
 * @returns {string} #d9dde2
 *  */
export const GRAY: string = '#d9dde2';

/**
 *  heavyGray
 * @returns {string} #909090
 *  */
export const HEAVY_GRAY: string = '#909090';

/**
 *  darkGray
 * @returns {string} #666
 *  */
export const DARK_GRAY: string = '#666';

/**
 *  black
 * @returns {string} #222
 *  */
export const BLACK: string = '#222';

/**
 *  darkBlack
 * @returns {string} #333
 *  */
export const DARK_BLACK: string = '#333';

/**
 *  white
 * @returns {string} #fff
 *  */
export const WHITE: string = '#fff';

/**
 *  grayBlue
 * @returns {string} #eff2fa
 *  */
export const GRAY_BLUE: string = '#eff2fa';

/**
 *  lightBlue
 * @returns {string} #00aeef
 *  */
export const LIGHT_BLUE: string = '#00aeef';

/**
 *  darkBlue
 * @returns {string} #05367b
 *  */
export const DARK_BLUE: string = '#05367b';

/**
 *  deepBlue
 * @returns {string} #4174b7
 *  */
export const DEEP_BLUE: string = '#4174b7';

/**
 *  orange
 * @returns {string} #ff7250
 *  */
export const ORANGE: string = '#ff7250';

/**
 *  green
 * @returns {string} #29ae3f
 *  */
export const GREEN: string = '#29ae3f';

/**
 *  red
 * @returns {string} #fb0006
 *  */
export const RED: string = '#fb0006';

/**
 *  box-shadow
 *  */
export const boxShadow = () => css`
  box-shadow: 11px 10px 12px 3px rgba(44, 41, 40, 0.5);
  -webkit-box-shadow: 11px 10px 12px 3px rgba(44, 41, 40, 0.5);
  -moz-box-shadow: 11px 10px 12px 3px rgba(44, 41, 40, 0.5);
`;
